import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import GlobalStyle from './GlobalStyle';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import dayjs from "dayjs";
import { FaEye } from "react-icons/fa";
import customParseFormat from "dayjs/plugin/customParseFormat";
import PastUnfulfilledModal from "./PastUnfulfilledModal";
import { fetchPastUnfulfilledOrders } from "./pastUnfulfilledUtils";
dayjs.extend(customParseFormat);

const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 5px;
  box-sizing: border-box;
`;

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
`;

const TableWrapper = styled.div`
 width: 100%;
 overflow-x: auto;
`;

const TopButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
`;

const Input = styled.input`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  flex: 1;
  min-width: 200px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fdfdfd;
  table-layout: fixed;
`;

const Th = styled.th`
  background-color: #f1f3f5;
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
  white-space: nowrap;
`;

const Td = styled.td`
  padding: 10px;
  border: 1px solid #ddd;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TdStyled = styled.td`
  border: 1px solid #ccc;
  padding: 8px;
  font-size: 14px;
  text-align: center;
  position: relative;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

.tooltip-custom {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
  margin-top: 4px;
}
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
`;

const Button = styled.button`
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background: #0056b3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const DriverColorDot = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${(props) => props.color || '#ccc'};
  margin-right: 8px;
  vertical-align: middle;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  max-width: 500px;
  max-height: 70vh;
  overflow-y: auto;
  border-radius: 8px;
`;

const Bolle = () => {
const [selectedBolla, setSelectedBolla] = useState(null);
const [searchFilter, setSearchFilter] = useState("");
const [bolle, setBolle] = useState([]);
const [modalOpen, setModalOpen] = useState(false);
const [currentPage, setCurrentPage] = useState(1);
const [dateFilter, setDateFilter] = useState("");
const [tooltipData, setTooltipData] = useState({ value: '', visible: false, x: 0, y: 0 });
const bollePerPage = 20;

const calcolaPrezzoConIva = (prezzo, iva) => {
  const cleanPrezzo = parseFloat(String(prezzo).replace(/[^\d.,-]/g, '').replace(',', '.'));
  const ivaPercent = parseFloat(iva || '0');
  if (isNaN(cleanPrezzo) || isNaN(ivaPercent)) return 0;
  return (cleanPrezzo * (1 + ivaPercent / 100)).toFixed(2);
};
const navigate = useNavigate();
const [show, setShow] = useState(false);
// Tooltip
 const TdWithTooltip = ({ children, tooltip }) => {
  return (
    <TdStyled onMouseEnter={() => setShow(true) } onMouseLeave={() => setShow(false)} >
      <span className="truncate block">{children}</span>
      {show && ( <div className="tooltip-custom"> {tooltip} </div> )}
    </TdStyled>
  );
 };
// Click per valore non troncato
const handleCellClick = (event, value) => {
  const rect = event.currentTarget.getBoundingClientRect();
  setTooltipData({
    value,
    visible: true,
    x: rect.left + window.scrollX,
    y: rect.bottom + window.scrollY,
  });
};
// ##############################

// Crea bolla di reso
  const handleCreateNewOrder = () => {
    function generateOrderId() {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yy = String(now.getFullYear()).slice(-2);
      const hh = String(now.getHours()).padStart(2, "0");
      const min = String(now.getMinutes()).padStart(2, "0");
      return `ORD_${dd}-${mm}-${yy}-${hh}-${min}`;
    }

const newOrderId = generateOrderId();
 navigate(`/add-bollereso/${newOrderId}`);
    };
// ##################################################


// Gestisci Bolle di reso
    const handleManageOrders = () => {
    navigate("/bolleresoedit");
  };

// Bolle arretrate: ordini non evasi dei giorni passati (stesse info del popup admin)
const [arretratiOpen, setArretratiOpen] = useState(false);
const [arretrati, setArretrati] = useState([]);
const handleBolleArretrate = async () => {
  try {
    setArretrati(await fetchPastUnfulfilledOrders());
  } catch (err) {
    console.error("Errore recupero ordini arretrati:", err);
    setArretrati([]);
  }
  setArretratiOpen(true);
};


// Get bolle #####
useEffect(() => {
  axios
    .get("/api/bolle")
    .then((response) => {
      if (Array.isArray(response.data)) {
        setBolle(response.data);
      }
    })
    .catch((error) => {
      console.error("Errore nel recupero bolle:", error);
    });
}, []);
// ###############

const [selectedOrderId, setSelectedOrderId] = useState("");
const openProductsModal = (bolla) => {
  setSelectedBolla(bolla);
  setModalOpen(true);
    };
  const closeModal = () => {
    setModalOpen(false);
    setSelectedBolla(null);
  };


// Filtri, paginazione, etc...
const filteredBolle = bolle.filter((bolla) => {
  const clienteNome = (bolla.clienteNome || "").toString().toLowerCase();
  const numeroDoc = (bolla.NUMERO_DOC || "").toString().toLowerCase();
  const orderId = (bolla.orderId || "").toString().toLowerCase();
  const filtro = searchFilter.toLowerCase();

  return (
    clienteNome.includes(filtro) ||
    numeroDoc.includes(filtro) ||
    orderId.includes(filtro)
  );
});

const indexOfLast = currentPage * bollePerPage;
const indexOfFirst = indexOfLast - bollePerPage;
const currentBolle = filteredBolle.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(filteredBolle.length / bollePerPage);

// Gestione click 
useEffect(() => {
  function handleClickOutside(event) {
    if (!tooltipData.visible) return;
    const tooltipElement = document.getElementById('order-tooltip');
    if (
      tooltipElement &&
      !tooltipElement.contains(event.target) &&
      !event.target.classList.contains('order-cell')
    ) {
      setTooltipData({ ...tooltipData, visible: false });
    }
  }
  document.addEventListener('click', handleClickOutside);
  return () => {
    document.removeEventListener('click', handleClickOutside);
  };
}, [tooltipData]);
// ###############################################

// DOWNLOAD PDF
const handleDownloadPDF = () => {
  if (!selectedBolla || !selectedBolla.products?.length) return;
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text(`Bolla ${selectedBolla.NUMERO_DOC}`, 14, 20);
  doc.setFontSize(12);
  doc.text(`Cliente: ${selectedBolla.clienteNome}`, 14, 30);
  doc.text(`Ordine: ${selectedBolla.orderId}`, 14, 38);
const total = selectedBolla.products.reduce((sum, prod) => {
  const quantity = parseFloat(prod.quantity) || 0;
  const prezzoIvato = parseFloat(calcolaPrezzoConIva(prod.price, prod.iva));
  return sum + quantity * prezzoIvato;
}, 0);

const tableData = selectedBolla.products.map((prod) => {
  const quantity = parseFloat(prod.quantity) || 0;
  const prezzoIvato = parseFloat(calcolaPrezzoConIva(prod.price, prod.iva));
  const totalRow = quantity * prezzoIvato;
  return [
    prod.productCode,
    prod.lot || "-",
    quantity.toString(),
    `${prezzoIvato.toFixed(2)} €`,
    `${totalRow.toFixed(2)} €`,
  ];
});

  tableData.push(['', '', '', 'Totale:', total.toFixed(2) + ' €']);
  doc.autoTable({
    startY: 45,
    head: [['Art', 'Lotto', 'Q.tà', 'Prz', 'Tot']],
    body: tableData,
  });

  doc.save(`bolla_${selectedBolla.orderId}_${selectedBolla.NUMERO_DOC}.pdf`);
};
// ########################################


  return (
    <>
      <GlobalStyle />
      <PastUnfulfilledModal
        open={arretratiOpen}
        orders={arretrati}
        onClose={() => setArretratiOpen(false)}
      />
      <PageContainer>
      <Content>
        <TopButtons>
          <Button onClick={handleCreateNewOrder}>Crea Bolla di reso</Button>
          <Button onClick={handleBolleArretrate}>Bolle arretrate</Button>
          <Button onClick={handleManageOrders}>Gestisci Bolle di reso</Button>
        </TopButtons>

<FiltersContainer>
  <Input
    type="text"
    placeholder="Filtra cliente / Data bolla"
    value={searchFilter}
    onChange={(e) => {
      setSearchFilter(e.target.value);
      setCurrentPage(1);
    }}
   />
</FiltersContainer>


<TableWrapper>
 <Table>
   <thead>
     <tr>
       <Th>Ordine</Th>
       <Th>Documento</Th>
       <Th>Data</Th>
       <Th>Cliente</Th>
       <Th>Prodotti</Th>
     </tr>
    </thead>
    <tbody>
    {currentBolle.length > 0 ? (
      currentBolle.map((bolla) => (
        <tr key={`${bolla.orderId}_${bolla.NUMERO_DOC}`}>
        <Td
         className="order-cell" onClick={(e) => handleCellClick(e, bolla.orderId)}
         style={{ cursor: "pointer" }} >
         <span className="truncate block">{bolla.orderId}</span>
        </Td>
          <Td>{bolla.NUMERO_DOC}</Td>
	  <Td>
           {dayjs(bolla.DATA_DOC, "MMM D YYYY h:mmA").isValid()
           ? dayjs(bolla.DATA_DOC, "MMM D YYYY h:mmA").format("DD/MM/YYYY")
           : "Data non valida"}
        </Td>
          <Td>{bolla.clienteNome}</Td>
          <Td>
	   <Button onClick={() => openProductsModal(bolla)} title="Visualizza prodotti">
            {window.innerWidth <= 768 ? <FaEye /> : "Visualizza prodotti"}
           </Button>
          </Td>
        </tr>
       ))
     ) : (
      <tr>
        <Td colSpan="5">Nessuna bolla trovata.</Td>
      </tr>
    )}
    </tbody>
   </Table>

         {tooltipData.visible && (
            <div
              style={{
                position: 'absolute',
                top: tooltipData.y,
                left: tooltipData.x,
                background: '#333',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: '6px',
                zIndex: 9999,
                maxWidth: '300px',
                pointerEvents: 'auto', // per permettere il click su tooltip
                userSelect: 'none',
              }}
              onClick={() => setTooltipData({ ...tooltipData, visible: false })}
            >
              {tooltipData.value}
            </div>
          )}

        </TableWrapper>

{modalOpen && selectedBolla && (
  <ModalOverlay onClick={closeModal}>
    <ModalContent onClick={(e) => e.stopPropagation()}>
      <h4>Bolla {selectedBolla.NUMERO_DOC}</h4>

      <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
        <thead>
          <tr>
            <th style={{ width: "20%", padding: "8px", textAlign: "left" }}>Art</th>
            <th style={{ width: "20%", padding: "8px", textAlign: "left" }}>Lotto</th>
            <th style={{ width: "20%", padding: "8px", textAlign: "right" }}>Q.tà</th>
            <th style={{ width: "20%", padding: "8px", textAlign: "right" }}>Prz</th>
            <th style={{ width: "20%", padding: "8px", textAlign: "right" }}>Tot</th>
          </tr>
        </thead>
    <tbody>
     {selectedBolla.products.map((prod, idx) => {
     const quantity = parseFloat(prod.quantity) || 0;
     const prezzoIvato = parseFloat(calcolaPrezzoConIva(prod.price, prod.iva));
     const total = quantity * prezzoIvato;
     return (
       <tr key={idx}>
         <td style={{ padding: "8px" }}>{prod.productCode}</td>
         <td style={{ padding: "8px" }}>{prod.lot || "-"}</td>
         <td style={{ padding: "8px", textAlign: "right" }}>{quantity}</td>
         <td style={{ padding: "8px", textAlign: "right" }}>{prezzoIvato.toFixed(2)} €</td>
         <td style={{ padding: "8px", textAlign: "right" }}>{total.toFixed(2)} €</td>
       </tr>
        );
        })}
    </tbody>
   </table>
    <p style={{ textAlign: "right", fontWeight: "bold", marginTop: "10px" }}>
    Totale bolla:{" "}
    {selectedBolla.products
    .reduce((sum, prod) => {
      const quantity = parseFloat(prod.quantity) || 0;
      const prezzoIvato = parseFloat(calcolaPrezzoConIva(prod.price, prod.iva));
      return sum + quantity * prezzoIvato;
     }, 0)
     .toFixed(2)} €
      </p>

      <TopButtons>
        <Button onClick={closeModal}>Chiudi</Button>
        <Button onClick={handleDownloadPDF}>Scarica PDF</Button>
      </TopButtons>
    </ModalContent>
  </ModalOverlay>
)}
	  {totalPages > 1 && (
          <Pagination>
            <Button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              ← Precedente
            </Button>
            <span>Pagina {currentPage} di {totalPages}</span>
            <Button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Successiva →
            </Button>
          </Pagination>
        )}
       </Content>
      </PageContainer>
    </>
  );
};

export default Bolle;
